import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Car, UserPlus, LogIn } from 'lucide-react';

function DriverLandingPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-purple-600 via-blue-600 to-purple-800">
      <Card className="w-full max-w-md mx-4">
        <CardHeader className="text-center">
          <div className="flex justify-center mb-4">
            <div className="bg-white p-4 rounded-full">
              <Car size={48} className="text-purple-600" />
            </div>
          </div>
          <CardTitle className="text-3xl">Roman Cars</CardTitle>
          <p className="text-gray-600 mt-2">Driver Portal</p>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="text-center mb-6">
            <p className="text-gray-700">
              Welcome to Roman Cars Driver Portal. Sign in to manage your rides and track your earnings.
            </p>
          </div>

          <Button 
            onClick={() => navigate('/driver/login')} 
            className="w-full h-12 text-lg"
            variant="default"
          >
            <LogIn size={20} className="mr-2" />
            Driver Login
          </Button>

          <Button 
            onClick={() => navigate('/driver/signup')} 
            className="w-full h-12 text-lg"
            variant="outline"
          >
            <UserPlus size={20} className="mr-2" />
            New Driver? Sign Up
          </Button>

          <div className="text-center mt-6 pt-6 border-t">
            <p className="text-sm text-gray-600">
              Need help? Contact us at{' '}
              <a href="mailto:info@romancars.uk" className="text-purple-600 hover:underline">
                info@romancars.uk
              </a>
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}

export default DriverLandingPage;
